export const BUY_ICE_CREAM= 'BUY_ICE_CREAM'